import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';
import { fontSizes } from '@liminal/brand/scale';
import { FONT_STACK_BODY } from '@liminal/brand/font-faces';

/**
 * The dense identifier cell used across every admin table: wallet ids, tx ids,
 * addresses, flag names.
 *
 * Eight byte-identical copies of this lived in eight page files, every one of
 * them asking for `monospace` — the OS generic — which overrode Helvetica
 * Monospaced Pro back to Courier or Menlo. The brand face is itself fixed-pitch
 * (web-ui/CLAUDE.md §4: table numerics use it precisely because it is tabular by
 * construction), so column alignment is preserved, and FONT_STACK_BODY still
 * ends in the OS generic as a fallback.
 *
 * Deliberately admin-local rather than in common/js/web-ui: nim-web renders no
 * tables, and the 12px density is an admin decision (the shared table layer --
 * DataTableBody, SortableTableCell -- keeps the theme's 14px).
 */
export const MonoCell = styled(TableCell)({
  fontFamily: FONT_STACK_BODY,
  fontSize: fontSizes.xs,
});
